var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2837AA",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-313 -870) translate(8 409) translate(73 277) translate(232 184)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#7896D2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 0H1.2C.54 0 .006.506.006 1.125L0 7.875C0 8.494.54 9 1.2 9h9.6c.66 0 1.2-.506 1.2-1.125v-6.75C12 .506 11.46 0 10.8 0zm-.407 2.488L8.4 3.656c-1.482.869-3.318.869-4.8 0l-2.014-1.18c-.215-.126-.292-.4-.173-.62.115-.214.381-.293.595-.178l.007.004L3.847 2.72c1.334.755 2.968.748 4.294-.02l1.733-1.001c.23-.133.522-.063.667.158.136.207.078.485-.128.62-.007.005-.013.009-.02.012z",
    transform: "translate(-313 -870) translate(8 409) translate(73 277) translate(232 184) translate(4 6)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardEmail);
export default __webpack_public_path__ + "static/media/contactCardEmail.5d35f6d370241759bacb4ae3b047919b.svg";
export { ForwardRef as ReactComponent };